export default __webpack_public_path__ + "static/randevu-siparis-mobil-uygulama-451d778d5954ee716ab1478548a71ad7.png";